<template>
  <div>
    <h1>关联判定结果</h1>
    <div
      style="
        font-size: 16px;
        text-align: left;
        margin: 0 auto;
        margin-bottom: 20px;
        width: 200px;
      "
      v-for="(code, key) in groupDatas"
      :key="key"
    >
      扫码{{ key + 1 }} -- {{ code.qrName }}
      <span v-if="key != 0">{{
        code.groupId == groupDatas[0].groupId ? '关联' : '不关联'
      }}</span>
    </div>
    <div class="scan" @click="scan">
      拍照上传<br/>
      关联码验证
      <input
        type="file"
        id="file"
        name="image"
        accept="image/*"
        capture="camera"
        @change="take"
      />
    </div>
    <div class="info">
      提示：<br />
      如果产品是第一次开箱，<br />
      编码不关联谨防假冒。
    </div>
    <canvas width height ref="myCanvas" class="hidden"></canvas>
    <FooterBtn
      v-if="page.buttons"
      :btns="page.buttons"
      :page="page"
    ></FooterBtn>
  </div>
</template>

<script>
import { getH5Pages } from '@/api/h5Pages'
import { listKsyCodeGroup } from '@/api/ksyCodeGroup'
import FooterBtn from '../main/components/footerBtn.vue'
export default {
  components: {
    FooterBtn
  },
  data () {
    return {
      groupDatas: [],
      page: { buttons: [] }
    }
  },
  created () {
    getH5Pages(this.$route.query.pageId).then(res => {
      // document.title = res.data.applet.name
      // res.data.links = JSON.parse(res.data.links)
      res.data.buttons = res.data.buttons.indexOf('[{') >= 0 ? JSON.parse(res.data.buttons) : res.data.buttons.split(',').map(item => {
        return { value: item, url: item == 4 ? this.form.remark : '' }
      })//res.data.buttons ? res.data.buttons.split(',') : []
      this.page = res.data
    })
  },
  methods: {
    scan () {

    },
    take () {

    },
    take: function () {
      var that = this;
      //是否支持canvas
      var _canvas = this.$refs.myCanvas;
      console.log(_canvas);
      if (!_canvas.getContext) {
        console.log(1)
        //将图片保存
        //that.paishetest();
        return;
      } else {
        console.log(2)
        that.paishetest1();
      }
    },
    paishetest1: function () {//有canvas提交
      var that = this;
      //原url："/ksy/home/compareImg" //人工url："/ksy/home/artificialCompareImg"

      that.basetoBlob(function (fd) {
        // http://39.98.50.243:9300/api/qr/identifyImg
        $.ajax({
          type: 'POST',
          // url: process.env.VUE_APP_BASE_API + "/system/productlabelimage/qr",//+ "/home/artificialCompareImg",
          url: process.env.VUE_APP_QR_API + '/api/qr/identifyImg',
          data: fd,
          dataType: "json",
          timeout: 30000,
          processData: false, // 不会将 data 参数序列化字符串
          contentType: false // 根据表单 input 提交的数据使用其默认的 contentType
        }).success(function (_res) {
          //   if (that.page.key == 11) {
          //     setTimeout(() => {
          //       window.location.href = _res.data.qr
          //       console.log(document.href)
          //     }, 100);
          //     return
          //   }
          console.log(_res.data.qr)
          listKsyCodeGroup({ qrUrl: _res.data.qr }).then(__res => {
            console.log(__res.rows[0])
            that.groupDatas.push(__res.rows[0])
          })
          return
          _res.data.fullPath = 'http://ksy7.cn/imgs/' + _res.data.fullPath
          if (_res.data.result == 1) {
            getDatabaseIsExits({ qrurl: _res.data.qr }).then(qr_res => {
              if (qr_res.rows.length > 0) {
                $.ajax({
                  type: 'POST',
                  url: that.webpath,//+ "/home/artificialCompareImg",
                  data: fd,
                  dataType: "json",
                  timeout: 30000,
                  processData: false, // 不会将 data 参数序列化字符串
                  contentType: false // 根据表单 input 提交的数据使用其默认的 contentType
                }).success(function (res) {
                  var code = res.status.code;
                  if (code == "2" || code == "3" || code == "4") {
                    // console.log(res.status.code, '---------')
                    if (res.data && res.data.qr && res.data.qr.indexOf('http://ksy7.cn/') > -1) {
                      let _qr = res.data.qr.replace('http://ksy7.cn/', '')
                      let _appletCode = _qr.slice(0, _qr.indexOf('/'))
                      console.log(res.data.qr, _qr, _appletCode)
                      if (_appletCode != that.applet.code) {
                        listH5Applet({ code: _appletCode }).then(_res => {
                          listH5Pages({ appletId: _res.rows[0].appletId }).then(__res => {
                            that.pages = __res.data
                            that.judgeModel(that, res, code)
                          })
                        })
                      } else {
                        console.log(res, code, '---------')
                        that.judgeModel(that, res, code)
                      }
                    } else
                      that.judgeModel(that, res, code)
                  } else
                    that.judgeModel(that, res, code)
                })
              } else {
                that.compared({ data: _res.data }, "8")
              }
            })
          } else {
            that.compared({ data: _res.data }, "7")
          }
        })
      })
    },
    basetoBlob: function (callback) {
      var that = this;
      that.changepic(function (_data) {

        //4.获取canvas中的图片信息
        //window.atob方法将其中的base64格式的图片转换成二进制字符串；若将转换后的值直接赋值给Blob会报错，需Uint8Array转换：最后创建Blob对象；
        _data = _data.split(',')[1];
        _data = window.atob(_data);
        //如果不用ArrayBuffer,发送给服务器的图片格式是[object Uint8Array],上传失败...
        var _buffer = new ArrayBuffer(_data.length);
        var _ubuffer = new Uint8Array(_buffer);
        for (var i = 0; i < _data.length; i++) {
          _ubuffer[i] = _data.charCodeAt(i);
        }
        // 安卓 UC浏览器不支持 new Blob()，使用BlobBuilder
        var _blob;
        try {
          _blob = new Blob([_buffer], { type: 'image/jpeg' });
        } catch (ee) {
          window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
          if (ee.name == 'TypeError' && window.BlobBuilder) {
            var _bb = new BlobBuilder();
            _bb.append(_buffer);
            _blob = _bb.getBlob('image/jpeg');
          }
        }

        var _suffix = 'jpg';
        if (_blob.type === 'image/jpeg') {
          _suffix = 'jpg';
        }
        var currentTime = (new Date()).getTime();
        var fileidNum = '' + currentTime + Math.floor(Math.random() * 10);
        //store.set('yanweiTime', currentTime);
        var fd = new FormData();
        // var _blob = dataURItoBlob(_data);
        fd.append('image', _blob, "file_" + Date.parse(new Date()) + ".jpg");
        fd.append('file', _blob, "file_" + Date.parse(new Date()) + ".jpg");
        fd.append('fileid', fileidNum);
        fd.append('addrssx', that.addrssx);
        fd.append('adcode', that.adcode);
        fd.append('company', that.antiCompany);//蜜蜂在线为1
        //				fd.append('big', "1");
        return callback(fd);
      })

    },
    changepic: function (callback) {
      var that = this;
      var reads = new FileReader();
      var images = new Image();
      var f = document.getElementById('file').files[0];
      var img64;
      reads.readAsDataURL(f);
      reads.onload = function (ev) {
        images.src = this.result;
        images.onload = function () {
          img64 = that.compress(images);
          //alert("图片的宽度为"+this.width+",长度为"+this.height);
          // var img64 = compress(images,500,400,0.7);
          return callback(img64);
        };
      }
    },
    compress: function (_img) {
      //2.计算符合目标尺寸宽高值，若上传图片的宽高都大于目标图，对目标图等比压缩；如果有一边小于，对上传图片等比放大。
      var _goalWidth = 1500,                  //目标宽度
        _goalHeight = 1500,                 //目标高度
        _imgWidth = _img.naturalWidth,     //图片宽度
        _imgHeight = _img.naturalHeight,   //图片高度
        _tempWidth = _imgWidth,            //放大或缩小后的临时宽度
        _tempHeight = _imgHeight,          //放大或缩小后的临时宽度
        _r = 1;                            //压缩比
      // alert('_tempWidth:'+_tempWidth+',_tempHeight:'+_tempHeight);


      if (_imgWidth === _goalWidth && _imgHeight === _goalHeight) {

      } else if (_imgWidth > _goalWidth && _imgHeight > _goalHeight) {//宽高都大于目标图，需等比压缩
        _r = _imgWidth / _goalWidth;
        if (_imgHeight / _goalHeight < _r) {
          _r = _imgHeight / _goalHeight;
        }
        _tempWidth = Math.ceil(_imgWidth / _r);
        _tempHeight = Math.ceil(_imgHeight / _r);
      } else {
        if (_imgWidth < _goalWidth && _imgHeight < _goalHeight) {//宽高都小于
          _r = _goalWidth / _imgWidth;
          if (_goalHeight / _imgHeight < _r) {
            _r = _goalHeight / _imgHeight;
          }
        } else {
          if (_imgWidth < _goalWidth) {         //宽小于
            _r = _goalWidth / _imgWidth;
          } else {                              //高小于
            _r = _goalHeight / _imgHeight;
          }
        }

        _tempWidth = Math.ceil(_imgWidth * _r);
        _tempHeight = Math.ceil(_imgHeight * _r);
      }


      //3.利用canvas对图片进行裁剪，等比放大或缩小后进行居中裁剪
      // var _canvas = e._$get('canvas-clip');
      // if(!_canvas.getContext) return;
      var _canvas = this.$refs.myCanvas;
      if (!_canvas.getContext) return;
      var _context = _canvas.getContext('2d');
      _canvas.width = _tempWidth;
      _canvas.height = _tempHeight;

      // alert('_imgWidth:'+_tempWidth+',_imgHeight:'+_tempHeight);
      _context.drawImage(_img, 0, 0, _tempWidth, _tempHeight);

      //toDataURL方法，可以获取格式为"data:image/png;base64,***"的base64图片信息；

      var _data = _canvas.toDataURL("image/jpeg");
      return _data;
    },
  }
}
</script>

<style lang="scss">
h1 {
  text-align: center;
  padding: 0.6rem !important;
  font-size: 0.56rem !important;
}
.hidden {
  display: none;
}
.scan {
  margin: 0 auto;
  position: relative;
  width: 30%;
  background: #126fb8;
  padding: 0.2rem;
  line-height: 0.4rem;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  input[type='file'] {
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1000;
  }
}
.info {
  width: 200px;
  margin: 0 auto;
  margin-top: 20px;
  line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/codeGroup/index.vue